import { render, staticRenderFns } from "./MarketingModal.vue?vue&type=template&id=616ae232&"
import script from "./MarketingModal.vue?vue&type=script&lang=js&"
export * from "./MarketingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports